module.exports = __webpack_public_path__ + "86885249112b0cdb2be4baae4bdd6de2.svg";